import { useQuery } from "react-query";

import { peopleQueryKeys } from "./queryKeys";
import { IPerson } from "../../models/person/Person";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function usePerson(personId?: string) {
  const { get } = useApiHelper();

  const person = useQuery(
    {
      queryKey: peopleQueryKeys.single(personId ?? ""),
      queryFn: () =>
        get(`/person/${personId}/`) as unknown as IDefaultResponseWithData<
          IPerson
        >,
      refetchOnWindowFocus: false,
      enabled: !!personId,
    },
  );

  return {
    person,
  };
}
